import { put } from "@redux-saga/core/effects";
import { all, takeEvery, call } from "redux-saga/effects";
import claimdataservices from "../../services/claimdataservices";
import { getbalanceresponse } from "../../services/getbalanceservice";
import { getclaimFailure, getclaimSuccess, getclaimrequest } from "./action";
import { GET_CLAIM } from "./types";

export function* getclaimdata({ payload }) {
  //console.log('payload')
  yield put(getclaimrequest());
  try {
    const result = yield call(claimdataservices, { payload });

    if (result) {
      yield put(getclaimSuccess(result));

      payload.navigate("/claim-detail");
      // payload.navigate('/dashboard')

      //    yield history.push('/claim-detail');
      //   history.go('./claim-detail')
      // toast.success(" Successfully")
      // yield history.push('/claim-details');
      // history.go('./claim-details')
    } else {
    }
  } catch (error) {
    //console.log('error-->', error)
    yield put(getclaimFailure(error.response.data.response.displayMsg));
  }
}

export default function* claimdataSaga() {
  yield all([takeEvery(GET_CLAIM, getclaimdata)]);
}
